<section class="container routing pt-5">
    <div class="d-flex justify-content-center align-items-center error mt-5">
        <div>
            <img src="./assets/images/succes-payment.png" alt="error">
            <h1 class="mt-3">{{'payment.payment success' | translate}}</h1>
            <p class="text-muted">{{'payment.payment Thank' | translate}}.</p>
        </div>
    </div>
</section>